<template>
    <div class="points-for" v-title="'福利活动中心'">
        <van-nav-bar fixed left-arrow :border="false" @click-left="$router.go(-1)">
            <template #title>
                <div>兑换礼品</div>
            </template>
        </van-nav-bar>
        <div class="integral-box">
            <div class="integral-num">
                <span>{{score}}</span>
                <i>速派积分</i>
            </div>
            <div class="integral-btn">
                <button @click="linkDetails">积分明细</button>
                <button @click="linkAddress">收货地址</button>
            </div>
        </div>
        <div class="switch-main">
            <ul>
                <li :class="{'on':groupType == 1}" @click="labelSwitch(1)">基础抽奖</li>
                <li :class="{'on':groupType == 2}" @click="labelSwitch(2)">高级抽奖</li>
            </ul>
        </div>
        <div class="lucky-draw-box">
            <div class="lucky-draw-label">
                <h3>积分抽奖</h3>
            </div>
            <div class="lottery">
                <div class="lottery-item">
                    <div class="lottery-start">
                        <template v-if="groupType == 1">
                            <div class="box" v-if="score>200">
                                <img src="@/assets/clock/jc-go.png" alt="" @click="startLottery">
                            </div>
                            <div class="box gray" v-else>
                                <img src="@/assets/clock/jc-go.png" alt="">
                            </div>
                        </template>
                        <template v-if="groupType == 2">
                            <div class="box" v-if="score>1000">
                                <img src="@/assets/clock/gj-go.png" alt="" @click="startLottery">
                            </div>
                            <div class="box gray" v-else>
                                <img src="@/assets/clock/gj-go.png" alt="">
                            </div>
                        </template>
                    </div>
                    <ul>
                        <li v-for="(item,i) in luckyList" :key="i" :class="i==index?'on':''">  
                            <div>
                                <p class="lw-img"><img :src="item.PrizeImgUrl" alt=""></p>
                                <p class="lw-tips">{{item.PrizeName}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="exchange-main">
            <h3 class="exchange-label">积分兑换</h3>
            <ul class="exchange-box">
                <li class="item-exchange" v-for="(item,index) in exchangeList" :key="index">
                    <div class="item-left">
                        <div class="items-icon">
                            <img :src="item.PrizeImgUrl" alt="icon">
                        </div>
                        <h4>{{item.PrizeName}}</h4>
                        <p>{{item.ExchangeScore}}积分</p>
                    </div>
                    <div class="item-right">
                        <button @click="exchangePrize(item)">兑换</button>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 中奖提示框 -->
        <van-popup v-model="showToast" class="clear-bg-color" :close-on-click-overlay="false">
            <div class="thanks-yes-box" v-if="showToast">
                <div class="thanks-tips thanks-tips1">获得{{luckyYes[0].PrizeName}}</div>
                <button class="thanks-confirm" v-if="!luckyYes[0].IsMall || luckyYes[0].IsSubmitShippingAddress" @click="showToast=false;getAccScoreInfo()">开 心 收 下</button>
                <button class="thanks-confirm" v-else @click="showToast=false;linkAddress()">去 完 善</button>
            </div>
        </van-popup>
    </div>
</template>
<script>
    import {
        GetAccScoreInfo,    // 获取用户积分信息
        GetPrizeList,       // 获取奖品列表
        DrawPrize,          // 抽奖
        ExchangePrize,      // 兑换奖品
    } from '@/common/api.js'
    import bridge from '@/common/dsbridge.js';
    import { Dialog } from 'vant';
    export default {
        data() {
            return {
                appUserInfo: null, //app里的用户信息
                userid: Number, //app里的用户id 不带p
                isWeb: true, //是否是浏览器 true 是 false 否


                score: '', //积分
                groupType: 1, //1基础抽奖 2高级抽奖

                luckyList: [], //抽奖列表
                index: -1, //起点位置
                count: 8, //总共多少个位置
                timer: 0, // 每次转动定时器
                speed: 200, // 初始转动速度
                times: 0, // 转动次数
                cycle: 50, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
                prize: -1, // 中奖位置
                click: true,
                showToast: false, //显示中奖弹窗

                luckyYes: [],       //中奖后的数据
                exchangeList: [],   //兑换列表


            }
        },
        computed: {
        },
        created() {
            bridge.register('getTitleInitData', function () {
                return '{"isShowTitleBar":false}'
            });
            this.getUserInfo()
        },
        mounted() {
            let self = this;
            self.getUserInfo();
        },
        methods: {
            // 获取用户信息
            getUserInfo() {
                this.getAccScoreInfo()
                this.getPrizeList(this.groupType)
                this.getPrizeList(4)
            },
            // 获取用户积分信息
            getAccScoreInfo() {
                let data = {}
                data.UserId = this.$route.query.userId
                GetAccScoreInfo(data).then(res => {
                    this.score = res.Data.ResidueScore
                })
            },
            // 切换label
            labelSwitch(type) {
                if (!this.click) {
                    return console.log('禁止')
                }
                this.index = -1;    // 起点位置
                this.timer = 0;     // 每次转动定时器
                this.speed = 200;   // 初始转动速度
                this.prize= -1;     // 中奖位置
                this.groupType = type
                this.getPrizeList(type)
            },
            // 获取奖品列表
            getPrizeList(type) {
                let data = {}
                data.PrizeGroupType = type
                data.UserId = this.$route.query.userId
                GetPrizeList(data).then(res => {
                    this.$nextTick(()=>{
                        if(type != 4) {
                            this.luckyList = res.Data
                        }else{
                            this.exchangeList = res.Data
                        }
                    })
                })
            },
            // 点击抽奖
            startLottery() {
                if (!this.click) {
                    return console.log('禁止')
                }
                this.click = false
                this.startRoll();
            },
            // 开始转动
            startRoll() {
                this.times += 1 // 转动次数
                this.oneRoll() // 转动过程调用的每一次转动方法，这里是第一次调用初始化
                // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
                if (this.times > this.cycle + 10 && this.prize === this.index) {
                    clearTimeout(this.timer) // 清除转动定时器，停止转动
                    this.prize = -1
                    this.times = 0
                    this.speed = 200
                    var that = this;
                    setTimeout(res => {
                        that.click = true;
                        that.showToast = true;
                    }, 500)
                } else {
                    if (this.times < this.cycle) {
                        this.speed -= 10 // 加快转动速度
                    } else if (this.times === this.cycle) {
                        let data = {}
                        data.UserId = this.$route.query.userId
                        data.PrizeGroupType = this.groupType
                        var index = Number;
                        DrawPrize(data).then(res=> {
                            if(res.Result == 1) {
                                this.luckyYes = this.luckyList.filter((item,idx) => {
                                    if(item.Id == res.Data.PrizeId) {
                                        index = idx
                                        item.IsMall = res.Data.IsMall
                                        item.IsSubmitShippingAddress = res.Data.IsSubmitShippingAddress
                                        return item
                                    }
                                })

                                this.prize = index; //中奖位置,可由后台返回 
                                if (this.prize > 7) {
                                    this.prize = 7
                                }
                            }else{
                                Dialog.alert({
                                    message: '系统繁忙请稍后重试!',
                                }).then(() => {
                                   this.$router.go(0)
                                });
                            }
                        })
                    } else if (this.times > this.cycle + 10 && ((this.prize === 0 && this.index === 7) || this.prize ===
                            this.index + 1)) {
                        this.speed += 110
                    } else {
                        this.speed += 20
                    }
                    if (this.speed < 40) {
                        this.speed = 40
                    }
                    this.timer = setTimeout(this.startRoll, this.speed)
                }
            },
            // 每一次转动
            oneRoll() {
                let index = this.index // 当前转动到哪个位置
                const count = this.count // 总共有多少个位置
                index += 1
                if (index > count - 1) {
                    index = 0
                }
                this.index = index
            },
            // 点击兑换奖品
            exchangePrize(row){
                let self = this
                if(row.IsDeliveryAddress && !row.IsSubmitShippingAddress) {
                    Dialog.alert({
                        message: '请填写收货地址！',
                    }).then(() => {
                        self.linkAddress()
                    });
                    return
                }
                let data = {}
                data.PrizeId = row.Id
                data.UserId = this.$route.query.userId
                ExchangePrize(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$toast(res.Message);
                    }
                    this.$toast.success('兑换成功')
                    setTimeout(()=>{
                        self.getAccScoreInfo()
                    },2000)
                })
            },
            // 点击积分明细
            linkDetails(){
                if (!this.click) {
                    return console.log('禁止')
                }
                this.$router.push({
                    path: '/integralDetail',
                    query: {
                        userId: this.$route.query.userId
                    }
                });
            },
            // 点击跳转收货地址
            linkAddress(){
                if (!this.click) {
                    return console.log('禁止')
                }
                this.$router.push({
                    path: '/integralAddress',
                    query: {
                        userId: this.$route.query.userId
                    }
                });
            },
        }
    }
</script>
<style lang="scss">
    @import '~@/style/_base.scss';

    .points-for {
        padding-top: px2rem(148px);
        @include bg('~@/assets/clock/head-clock-bg.png');
        background-position: top center;
        background-size: 100% px2rem(490px);
        padding-bottom: px2rem(60px);
        min-height: 100vh;

        .van-nav-bar--fixed {
            @include bg('~@/assets/clock/head-clock-bg.png');
            background-position: left 0 !important;
            background-size: cover;
            top: 0;
            background-color: transparent !important;
            height: px2rem(158px);
            padding-top: px2rem(70px);

            .van-nav-bar__content {
                height: px2rem(88px);
            }

            i,
            div {
                color: #ffffff;
            }

            i:before {
                color: #ffffff;
            }
        }

        .integral-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            height: px2rem(100px);
            margin-top: px2rem(20px);
            margin-bottom: px2rem(10px);
            padding: 0 px2rem(28px);

            .integral-num {
                >* {
                    color: #ffffff;

                }

                span {
                    font-size: px2rem(62px);
                    font-weight: 600;
                    line-height: 38px;
                }

                i {
                    padding-left: px2rem(6px);
                    font-size: px2rem(24px);
                }
            }

            .integral-btn {
                margin-right: px2rem(-20px);

                button {
                    width: px2rem(120px);
                    height: px2rem(48px);
                    background: #ff7748;
                    border-radius: px2rem(24px);
                    font-size: px2rem(24px);
                    line-height: px2rem(26px);
                    color: #ffffff;
                    margin-right: px2rem(20px);
                }
            }
        }

        .switch-main {
            padding: 0 px2rem(28px);

            ul {
                li {
                    display: inline-block;
                    vertical-align: top;
                    font-size: px2rem(28px);
                    font-weight: 400;
                    color: #ffffff;
                    margin-right: px2rem(105px);
                    position: relative;
                    line-height: px2rem(62px);
                }

                li.on {
                    font-size: px2rem(32px);
                    font-weight: 600;

                    &::after {
                        content: '';
                        width: 90%;
                        height: px2rem(6px);
                        border-radius: px2rem(3px);
                        position: absolute;
                        bottom: px2rem(-6px);
                        left: 50%;
                        transform: translateX(-50%);
                        background: #ffffff;
                    }
                }
            }
        }

        .lucky-draw-box {
            margin: px2rem(28px) px2rem(28px) 0;
            padding: px2rem(15px) px2rem(28px);
            background: #ffffff;
            box-shadow: 0px 10px 23px 1px rgba(0, 0, 0, 0.04);
            border-radius: 20px;

            .lucky-draw-label {
                display: flex;
                justify-content: center;
                margin-top: px2rem(28px);
                margin-bottom: px2rem(43px);

                h3 {
                    min-width: px2rem(286px);
                    max-width: px2rem(286px);
                    height: px2rem(40px);
                    font-size: 0;
                    @include bg('~@/assets/clock/img-label.png');
                }
            }

            // 抽奖九宫格
            .lottery {
                .lottery-item {
                    margin-left: px2rem(12px);
                    margin-right: px2rem(12px);
                    min-height: px2rem(560px);
                    position: relative;

                    .lottery-start {
                        position: absolute;
                        left: px2rem(216px);
                        top: px2rem(172px);
                        // left: px2rem(208px);
                        // top: px2rem(178px);
                        width: px2rem(180px);
                        height: px2rem(180px);
                        // width: px2rem(198px);
                        // height: px2rem(168px);
                        border-radius: px2rem(13px);

                        >div {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: initial;
                            height: inherit;

                            img {
                                display: block;
                                width: px2rem(170px);
                                height: px2rem(170px);
                                object-fit: cover;
                            }
                        }

                        .box {
                            img {
                                -webkit-filter: grayscale(0);
                            }
                        }

                        .gray {
                            img {
                                -webkit-filter: grayscale(.95);
                            }
                        }
                    }

                    ul {
                        li {
                            width: px2rem(198px);
                            height: px2rem(168px);
                            position: absolute;
                            background: #FEFAF1;
                            border-radius: px2rem(13px);
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            >div {
                                .lw-img {
                                    margin: 0 auto px2rem(6px);
                                    width: px2rem(68px);
                                    // min-width: px2rem(68px);
                                    // max-width: px2rem(82px);
                                    height: px2rem(72px);
                                    display: flex;
                                    align-items: center;
                                    overflow: hidden;

                                    img {
                                        display: block;
                                        width: 100%;
                                        height: auto;
                                        object-fit: cover;
                                    }
                                }

                                .lw-tips {
                                    text-align: center;
                                    font-size: px2rem(22px);
                                    color: #333333;
                                    padding: 0 px2rem(20px);
                                    font-weight: 500;
                                    line-height: px2rem(30px);
                                    height: px2rem(60px);
                                    display: flex;
                                    align-items: center;
                                }

                            }

                            &:nth-child(2) {
                                left: px2rem(208px);
                                top: 0;
                            }

                            &:nth-child(3) {
                                left: px2rem(416px);
                                top: 0;
                            }

                            &:nth-child(4) {
                                left: px2rem(416px);
                                top: px2rem(178px);
                            }

                            &:nth-child(5) {
                                left: px2rem(416px);
                                top: px2rem(358px);
                            }

                            &:nth-child(6) {
                                left: px2rem(208px);
                                top: px2rem(358px);
                            }

                            &:nth-child(7) {
                                left: 0;
                                top: px2rem(358px);
                            }

                            &:nth-child(8) {
                                left: 0;
                                top: px2rem(178px);
                            }
                        }

                        li.on {
                            background: #FDE56E;
                        }
                    }
                }
            }
        }

        .exchange-main {
            margin: px2rem(40px) px2rem(28px) 0;
            padding: px2rem(15px) px2rem(28px);
            background: #ffffff;
            box-shadow: 0px 10px 23px 1px rgba(0, 0, 0, 0.04);
            border-radius: 20px;

            .exchange-label {
                text-align: center;
                color: #333333;
                font-size: px2rem(32px);
                font-weight: bold;
                line-height: px2rem(72px);
            }

            .exchange-box {
                padding-bottom: px2rem(10px);

                li.item-exchange {
                    min-height: px2rem(168px);
                    border-bottom: 1px solid #e6e6e6;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .item-left {
                        position: relative;
                        padding-left: px2rem(147px);

                        .items-icon {
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            background: #000;
                            width: px2rem(120px);
                            height: px2rem(100px);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #F6F6F6;

                            img {
                                display: block;
                                width: px2rem(72px);
                                height: px2rem(74px);
                                object-fit: cover;
                            }
                        }

                        h4 {
                            font-size: px2rem(30px);
                            color: #333333;
                            font-weight: 500;
                            line-height: px2rem(30px);
                        }

                        p {
                            color: #fea828;
                            font-size: px2rem(26px);
                            font-weight: 400;
                            line-height: px2rem(26px);
                            padding-top: px2rem(40px);
                        }
                    }

                    .item-right {
                        text-align: right;

                        button {
                            width: px2rem(178px);
                            height: px2rem(62px);
                            text-align: center;
                            border-radius: px2rem(31px);
                            color: #ffffff;
                            font-size: px2rem(26px);
                            margin-top: px2rem(40px);
                            background: linear-gradient(88deg, #FF7216, #FF3E15);
                        }
                    }
                    &:last-child {
                        border-bottom: none;
                    }
                }

            }
        }


    }
    .clear-bg-color {
        background: none;
    }
    .thanks-yes-box {
        position: relative;
        text-align: center;
        width: px2rem(704px);
        height: px2rem(708px);
        background-size: contain;
        background-position: center top;
        @include bg('~@/assets/clock/thanks.png');

        .thanks-tips {
            font-size: px2rem(32px);
            color: #F7781C;
            font-weight: 500;
            line-height: px2rem(48px);
            width: 32%;
            margin: 0 auto;
        }

        .thanks-tips1 {
            padding-top: px2rem(324px)
        }

        .thanks-confirm {
            position: absolute;
            bottom: px2rem(154px);
            left: px2rem(196px);
            color: #ffffff;
            width: px2rem(313px);
            height: px2rem(58px);
            font-size: px2rem(28px);
            border-radius: px2rem(29px);
            background: linear-gradient(0deg, #FDD30C, #FFF200);
        }
    }
</style>